<nb-card>

  <nb-card-header>
    <div i18n="@@Goals">Goals</div>
  </nb-card-header>

  <nb-card-body>

    <ng2-smart-table
      class="order-smart-table"
      [settings]="GoalTableSettings"
      [source]="GoalsSource"
      (edit)="onEdit($event)"
      (delete)="onDelete($event)"
    >
    </ng2-smart-table>
  </nb-card-body>

  <nb-card-footer>
    <table>
      <tr>
        <td><button i18n="@@AddNew" type="submit" class="btn-circle btn-xl btn-main btn-circle btn-xl" (click)="AddGoal()">{{AddPatientLabel}}</button></td>
        <td><button i18n="@@Back" nbButton class="btn-circle btn-xl btn-main btn-circle btn-xl" status="info" (click)="Back()">{{BackLabel}}</button></td>
      </tr>
    </table>
  </nb-card-footer>


</nb-card>
